module.exports = __webpack_public_path__ + "static/media/box.16d5e850.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/box.svg
// module id = 367
// module chunks = 7